<article class="details-page-wrapper"
  [matTooltip]="currentState?.name"
  [matTooltipDisabled]="isActive"
  matTooltipClass="dark-theme-tooltip simple drawer-name-tooltip"
  matTooltipPosition="left"
>
  <loader [isVisible]="!formData"></loader>

  <ng-container *ngIf="formData">
    <drawer-header
      [detailsFormGroupData]="formData"
      [actions]="menuActions"
      [hasUnsavedChanges]="unsavedChangesFlag"
      [nameFormControl]="fdNameControl"
      [maxObjectNameLength]="budgetNameMaxLength"
      [objectType]="objectType"
      [objectLabel]="objectLabel"
      [createdDate]="currentState?.created"
      [updatedDate]="currentState?.updated"
      [headerBackgroundClass]="headerBackgroundClass[objectType]"
      [isCEGBudget]="cegStatusEnabled"
      [disableSaveAndCloseButton]="!isFormValid"
      (cancel)="handleCancelAction()"
      (saveAndClose)="submitChanges(handleSaveAndCloseAction.bind(this))"
      [saveButtonWithMenu]="false"
    ></drawer-header>

    <budget-drawer-details-form
      [ownerOptions]="ownerOptions"
      [formData]="formData"
      [companyCurrency]="companyCurrency"
      [budgetId]="objectId"
      [companyId]="companyId"
      [isEditMode]="isEditMode"
      [isFAB]="isFAB"
      [isForecastEnabled]="isForecastEnabled"
      [selectedFieldIds]="selectedFormulaIds"
      [selectedFieldNames]="selectedFormulaNames"
      [defaultSelectedFormulaIds]="defaultSelectedFormulaIds"
      [defaultSelectedFormulaNames]="defaultSelectedFormulaNames"
      [managePageFieldsKeyed]="managePageFieldsKeyed"
      [canDisableForecast]="canDisableForecast"
      (handleOwnerChange)="onOwnerChanged($event)"
      (handleTimeframeTypeChange)="onTimeframeTypeChanged($event)"
      (startDateChanged)="onStartDateChanged($event)"
      (forecastEnabledChanged)="handleForecastChange($event)"
      (cabFormulaChanged)="onCABFormulaChanged($event)"
      (syncUnsavedChangesFlag)="syncUnsavedChangesFlag($event)"
    ></budget-drawer-details-form>
  </ng-container>
</article>
